<template>
  <div class="article-details">
    <PageHeader :page-title="title" :showBackButton="!previewMode">
        <template v-slot:actions>
          <b-button v-if="!previewMode" v-can-write:[articleOwner]="$permissions.WRITE_OTHER_ARTICLE" :key="articleOwner" @click="editArticle()" variant="primary">
            <span class="d-none d-sm-inline">Redigera</span> <i class="fas fa-edit"></i>
          </b-button>
        </template>
    </PageHeader>
    <Article v-if="article && article.id" :articleId="article.id" :previewMode="previewMode" :key="article.id"></Article>
  </div>
</template>

<script>
import PageHeader from '@/layouts/components/PageHeader.vue'
import { BButton } from 'bootstrap-vue'
import Article from '@/components/Article/Article.vue'
import { mapGetters } from 'vuex'

export default {
  props: ['id', 'title',  'previewMode', 'type'],
  data(){
    return {
      currentArticle: {},
      isArticleOwner: true
    }
  },
  created() {
    this.$nextTick(function(){
      this.onCreated()
    });
  },
  watch: {
    '$route': function(){
      //on route change re run: 
      this.onCreated()
    }
  },
  computed: {
    ...mapGetters(['getArticleById', 'getArticleAboutMe']),
    article: function(){
      return this.currentArticle;
    },
    articleOwner: function(){
      return this.isArticleOwner;
    }
  },
  methods: {
    onCreated(){
      if(this.type === "about-me"){
        this.currentArticle = this.getArticleAboutMe;
      }
      else{
        this.currentArticle = this.getArticleById(this.id);
      }
      this.isArticleOwner = this.$currentUserId() == (this.currentArticle.owner.id ?? this.currentArticle.owner);
    },
    editArticle() {
      this.$router.push({ name: 'article-add', params: { articleId: this.id } }); 
    },
    back(){
      this.$router.go(-1) 
    }
  },
  components:{
      PageHeader,
      BButton,
      Article
    }
}
</script>

<style>

</style>